export default "__VITE_ASSET__2ac0569b__"